import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=7897b7e0&scoped=true&"
import script from "./ProductSettings.vue?vue&type=script&lang=js&"
export * from "./ProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=7897b7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897b7e0",
  null
  
)

export default component.exports